import React, { useEffect } from 'react'
import { useBindingInfoAPI } from '../../components/BindingInfoHook/useBindingInfoAPI'
import {openDeeplink} from "../CommonFunction";
import * as qs from "query-string";

const MiddleScreenInZaloPay = () => {
    const bindingInfo = useBindingInfoAPI();
    const { app_id: appid } = bindingInfo || {}
    let params = qs.parse(window.location.href.split('?')[1]);
    useEffect(() => {
        if (appid) {
            openDeeplink(bindingInfo, params.redirect_url, "webinapp");
        }
    }, [appid])

    return <React.Fragment></React.Fragment>
}

export default MiddleScreenInZaloPay
